let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h6nSo")).then(() => parcelRequire('dKYWq'));